const IDLE = {
    action: 'idle'
};
export const planIntercomSession = (param)=>{
    let { isRealUser, enabledForRoute, featureFlagsLoaded, lastMode } = param;
    if (!isRealUser || !enabledForRoute) {
        return lastMode === 'shutdown' ? IDLE : {
            action: 'shutdown'
        };
    }
    if (!featureFlagsLoaded) {
        return IDLE;
    }
    return {
        action: 'start',
        shutdownFirst: lastMode === 'jwt'
    };
};
